"use client"

import { useState } from "react"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Star } from "lucide-react"

const reviews = [

	{
		name: "Ольга П.",
		text: `С Оксаной работала в гипнозе.
И это было мощно, на минуточку до этого вообще не участвовала в чем то подобном, т. к уровень контроля у меня зашкаливает всегда и всё пропускаю через сознание.
НО т к я безгранично доверяю Оксане и в коучинге с ней достигла много своих целей я пошла в этот новый для себя опыт- гипноз
И это было 🔥🔥🔥🔥.
1.я смогла расслабить тело (обычно даже перед сном мне это тяжело даётся)
2. Вначале умудрялась анализировать приходящие картинки и быть в моменте (контроль и здесь не отпускал до конца)
3. Где-то на середине я погрузилась полностью в процесс и получала кайф от ярких картинок, запахов и атмосферы.
4. Получила ответ с чего начать для работы над своим запросом
5. Как бонус восстановила свою энергию после 2х дней ведения тренинга, что ОЧЕНЬ энергозатратно
От души советую попробовать этот инструмент для разговора со своим внутренним мудрецом`,
		rating: 5,
	},
  	{
		name: "Владимир Ю.",
		text: `Оксана - потрясающий психолог. С первого сеанса я чувствовал себя комфортно, делясь своими самыми сокровенными мыслями и эмоциями. Ее способность внимательно слушать и задавать проницательные вопросы создаёт безопасное и поддерживающее пространство.
Тяжело мужчине с фоббиями ходить к специалисту, многие отказавались или пренебрежительно относились. Помимо эмоциональной поддержки, получил план стратегии действий как решить мою проблему. Честно, за месяц, я добился такого прогресса под руководством Оксаны, что годами ходивший по другим психологам и психиатрам, и толку было 0. Очень сильно благодарен судьбе что встретил именно этого специалиста 🙏`,
		rating: 5,
	},
	{
		name: "Мария С.",
		text: "Работали с Оксаной 5 сессий. За это время я избавилась от тревожности и депрессивного состояния. Моё настроение улучшилось и появилось желание жить. Отстала от взрослого ребенка, поработав на тему сепарации. Также избавилась от клаустрофобии, которая была у меня более 20 лет. После последней сессии смогла спуститься в лифте. Благодарю за эффективную работу и очень лёгкую поддерживающую коммуникацию",
		rating: 5,
	},
]

export default function Reviews() {
	return (
		<section id="reviews" className="py-20 bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-12">
					<h2 className="text-4xl font-bold text-gray-900 mb-4">Отзывы клиентов</h2>
					<p className="text-xl text-gray-600">Реальные истории и впечатления</p>
				</div>
				<div className="flex flex-col md:flex-row gap-8 md:gap-12 items-stretch justify-center">
					{reviews.map((review, idx) => {
						const [expanded, setExpanded] = useState(false)
						const isLong = review.text.length > 150
						const displayText = isLong && !expanded ? review.text.slice(0, 150) + "..." : review.text
						return (
							<Card key={idx} className="flex-1 h-full shadow-xl border-0 bg-white">
								<CardHeader className="flex flex-col items-center pt-8 pb-4">
									<div className="flex gap-1 mb-2">
										{[...Array(review.rating)].map((_, i) => (
											<Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
										))}
									</div>
									<div className="font-semibold text-lg text-gray-800">{review.name}</div>
								</CardHeader>
								<CardContent className="px-8 pb-8 text-center text-gray-700 text-base">
									<p>"{displayText}"</p>
									{isLong && (
										<Button variant="outline" size="sm" className="mt-4 text-blue-600 border-blue-300 hover:bg-blue-50 hover:text-blue-800 transition" onClick={() => setExpanded((prev) => !prev)}>
											{expanded ? "Скрыть" : "Показать полностью"}
										</Button>
									)}
								</CardContent>
							</Card>
						)
					})}
				</div>
			</div>
		</section>
	)
}
